{
  "fr": {
    "pricingPlans": {
      "error": {
        "loading": "Erreur lors du chargement de l'aperçu des prix"
      },
      "index": {
        "headings": {
          "benefits": "Les offres fobizz en un coup d'œil"
        },
        "newLayout": {
          "header": {
            "title": "Quel fobizz te convient ?",
            "subtitle": "Nous t'aidons à rendre ton enseignement plus interactif et numérique"
          },
          "individualSection": {
            "title": "Licence individuelle fobizz - Pour toi personnellement"
          },
          "groupSection": {
            "title": "Utiliser fobizz avec des collègues",
            "groupLicense": {
              "title": "Licences pour groupes",
              "descriptionHtml": "La licence de groupe est rentable dès <strong>5 personnes</strong>.",
              "linkText": "Infos sur la licence de groupe",
              "url": "https://fobizz.com/de/angebote-fuer-schulen-und-gruppen/"
            },
            "groupJoin": {
              "title": "Activer la licence de groupe",
              "description": "Votre établissement a déjà une licence ?",
              "instruction": "Associe ton compte ici :"
            }
          },
          "trialSection": {
            "title": "Pas encore sûr de ce qui te convient ?",
            "description": "Active ton mois d'essai gratuit et teste sans engagement toutes les fonctionnalités de la formule combinée.",
            "placeholder": "Code promo",
            "button": "Commencer le mois d'essai",
            "error": "Le code promo est invalide."
          }
        },
        "paragraphs": {
          "benefitsIntro": "Avec la formule combinée, tu peux utiliser toutes les offres fobizz sans limite. Avec un compte gratuit, tu peux tester fobizz sans engagement, utiliser un extrait du catalogue de formations et obtenir une limite mensuelle pour les outils. Compare toutes les options ici :"
        },
        "footer": {
          "pricingInfo": "Tous les prix par personne incluent la TVA allemande."
        },
        "limitsTable": {
          "unlimited": "Illimité"
        }
      },
      "links": {
        "getStarted": "S'inscrire maintenant"
      }
    }
  }
}
